import React, { useCallback, useEffect } from 'react';
import { Checkbox, Grid, TextField, Typography } from '@mui/material';
import {
    CheckCircle as CircleChecked,
    RadioButtonUnchecked as CircleUnchecked,
} from '@mui/icons-material';
import { times } from 'lodash';
import useTaskField from '@dyl/pages/Tasks/edit/useTaskField';
import PropTypes from 'prop-types';
import { limitWordsAndSpaces } from '../utils/limitWordsAndSpaces';
import { createOnPasteAtCaret } from '@dyl/utils/pasteAtCaret';

export default function PersonalIntroductionOption({
    path = [''],
    fieldName = 'text'
}) {
    useEffect(() => {
        console.assert(!!path, 'No path specified!');
    }, [path]);

    const [array] = useTaskField(path);

    return (
        <Grid container spacing={2} style={{ flexDirection: 'column' }}>
            {times(array?.length, index => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                    <Item parent={path} index={index} fieldName={fieldName} />
                </Grid>
            ))}
        </Grid>
    );
}
PersonalIntroductionOption.propTypes =  {
  path: PropTypes.array.isRequired,
  fieldName: PropTypes.string
}

function Item({ parent, index, fieldName = 'text' }) {
    const useField = (...args) => useTaskField(parent, index, ...args);

    const [, setItems] = useTaskField(parent);

    const [text, setText, textError] = useField(fieldName);

    const [isCorrect] = useField('is_correct_answer');

    const setAsCorrect = useCallback(() => {
        setItems(prev => prev.map((a, i) => ({
            ...a,
            is_correct_answer: i === index,
        })));
    }, [index, setItems]);

    const letterId = String.fromCharCode('A'.charCodeAt(0) + index);

        const onTextChange = useCallback((event) => {
            const prev = text || '';
            const restricted_text = limitWordsAndSpaces(prev, 12, event.target.value, 'A2');
            setText(restricted_text);
        }, [setText, text]);

        const onPaste = useCallback(createOnPasteAtCaret(setText, text, 12), [text, setText]);

    return (
        <div style={{ display:'flex', alignItems:'flex-start' }}>
            <Checkbox
                checked={isCorrect}
                onClick={setAsCorrect}
                icon={<CircleUnchecked />}
                checkedIcon={<CircleChecked />}
                color='primary'
                sx={{ alignItems: 'flex-start' }}
            />
        <div style={{ paddingTop: '8px' }}>
          <Typography sx={{ fontSize: '16px', fontWeight: 'bold', marginBottom:'4px' }}>{`Option ${letterId}`}</Typography>
          <TextField
            fullWidth
            value={text}
            variant='filled'
            onChange={onTextChange}
            onPaste={onPaste}
            error={!!textError}
            helperText={textError ?? 'Select if key'}
            sx={{ width:'855px', '& .MuiInputBase-input' : { width: '855px' }}}
          />
        </div>
        </div>
    );
}
Item.propTypes = {
  parent: PropTypes.any.isRequired,
  index: PropTypes.number.isRequired,
  fieldName: PropTypes.string
}